import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-455a5417"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kanban-task-attachment d-flex gap-2 justify-content-start align-items-start rounded-1 py-1" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "kanban-task-attachment__details d-flex flex-column" }
const _hoisted_4 = { class: "kanban-task-attachment__details__title" }
const _hoisted_5 = { class: "kanban-task-attachment__details__links d-flex gap-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  disabled: ""
}, "Comment", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  disabled: ""
}, "Delete", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  disabled: ""
}, "Edit", -1))
const _hoisted_12 = { class: "kanban-task-attachment__details__remove d-flex gap-2 mt-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-image" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "kanban-task-attachment__img",
      src: `${_ctx.$STATIC_URL}/${_ctx.attachment.name}`,
      alt: "board"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.attachment.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.attachment.createdAt), 1),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleMakeAttachmentCover(_ctx.attachment)), ["prevent"])),
          class: "text-underline"
        }, _toDisplayString(_ctx.attachment.isCover ? 'Remove Cover' : 'Make Cover'), 1)
      ])
    ])
  ]))
}